module.exports = __webpack_public_path__ + "img/catch-hr-1.d0787b45.jpg";